import stls from '@f_qwep/styles/component/settings/Suppliers.module.sass';

export function CellTitle({ info }: any) {
    return <p className={stls.cellTitle}>{info.row.original.title}</p>;
}
